import { ACCOUNT_CONTACT_DETAILS_PHRASES } from '@/consts/phrases/accountPhrases';
import { accountService } from '@/services/api';
import { FetchErrorsType } from '@/types';
import { getFetchErrors } from '@/utils/getFetchErrorMessage';
import { FieldValues, UseFormSetError } from 'react-hook-form';
import { usePhrase } from '@/hooks';

export type CodeReturnError = {
    type: 'request' | 'missingParam';
    error: FetchErrorsType;
    originalError?: unknown;
};

interface SendMobileCodeReturn {
    success:
        | {
              mobilePhoneCodeId: number;
          }
        | undefined;
    error: CodeReturnError | undefined;
}

export const sendMobileCode = async (
    mobilePhone: string | undefined,
    countryCode: string | undefined,
): Promise<SendMobileCodeReturn> => {
    try {
        if (mobilePhone && countryCode) {
            const res = await accountService.sendSMSCode(mobilePhone, countryCode);
            return {
                success: {
                    mobilePhoneCodeId: res,
                },
                error: undefined,
            };
        } else {
            return {
                success: undefined,
                error: {
                    type: 'missingParam',
                    error: {
                        generalErrors: [
                            {
                                message: String(
                                    ACCOUNT_CONTACT_DETAILS_PHRASES.INVALID_MOBILE_PHONE_NUMBER,
                                ),
                                phraseId:
                                    ACCOUNT_CONTACT_DETAILS_PHRASES.INVALID_MOBILE_PHONE_NUMBER,
                            },
                        ],
                        propertyErrors: {},
                    },
                },
            };
        }
    } catch (err) {
        return {
            success: undefined,
            error: {
                type: 'request',
                error: getFetchErrors(err),
                originalError: err,
            },
        };
    }
};

export const setMobileCodeError = (
    error: CodeReturnError,
    setError: UseFormSetError<FieldValues>,
    t: ReturnType<typeof usePhrase>['t'],
    fieldName?: string,
) => {
    const errorDataPhraseId =
        error.error?.propertyErrors?.mobilePhone?.[0]?.phraseId ||
        error.error?.generalErrors[0]?.phraseId;
    const errorDataPhrasePlaceholders =
        error.error?.propertyErrors?.mobilePhone?.[0]?.phrasePlaceholders ||
        error.error?.generalErrors[0]?.phrasePlaceholders;

    if (errorDataPhraseId) {
        setError(
            fieldName ?? 'mobilePhone',
            {
                type: 'custom',
                message: t(errorDataPhraseId, {
                    replaceTextVars: errorDataPhrasePlaceholders,
                    asString: true,
                }),
            },
            {
                shouldFocus: true,
            },
        );
    }
};
